module.exports = __webpack_public_path__ + "img/cash-received-from-costumer.cdb41848.svg";